import IActiveOrInactiveDTO from '../dtos/IActiveOrInactiveDTO'
import IVeiculosRepository from '../repositories/IVeiculosRepository'
export interface IActiveOrInactive {
  execute(params: IActiveOrInactiveDTO): Promise<void>
}

export default class IActiveOrInactiveImpl implements IActiveOrInactive {
  constructor(private readonly veiculoRepository: IVeiculosRepository) {}

  public async execute(params: IActiveOrInactiveDTO): Promise<void> {
    await this.veiculoRepository.activeOrInactive(params)
  }
}
